import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/play/play/apps/play-portal/src/app/_components/analytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Dashboard"] */ "/home/runner/work/play/play/apps/play-portal/src/components/Dashboard/Dashboard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConnectionProvider"] */ "/home/runner/work/play/play/apps/play-portal/src/hooks/connection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Carousel"] */ "/home/runner/work/play/play/libs/ui-kit/src/Carousel/Carousel.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/play/play/libs/ui-kit/src/ContentBox/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/play/play/libs/ui-kit/src/GameHeader/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/play/play/libs/ui-kit/src/GamesGrid/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/play/play/libs/ui-kit/src/GameSpecs/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/play/play/libs/ui-kit/src/hooks/screenSizeHooks.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/work/play/play/libs/ui-kit/src/hooks/useSpyScrollPercentage.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/work/play/play/libs/ui-kit/src/hooks/useTimeCountdown.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/work/play/play/libs/ui-kit/src/Loader/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/play/play/libs/ui-kit/src/MediaCarousel/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PromotionTile"] */ "/home/runner/work/play/play/libs/ui-kit/src/PromotionTile/PromotionTile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RenderOnceInView"] */ "/home/runner/work/play/play/libs/ui-kit/src/RenderOnceInView/RenderOnceInView.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/play/play/libs/ui-kit/src/SectionDivider/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/play/play/node_modules/next/dist/client/image-component.js");
